import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ZoomchartsService } from './zoomcharts.service';
import { ChartService } from './chart.service';

import { PiechartComponent } from './piechart/piechart.component';
import { FacetchartComponent } from './facetchart/facetchart.component';
import { ZoomchartsComponentComponent } from './zoomcharts-component/zoomcharts-component.component';
import { TimechartComponent } from './timechart/timechart.component';
import { NetchartComponent } from './netchart/netchart.component';
import { GeochartComponent } from './geochart/geochart.component';


@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    PiechartComponent,
    FacetchartComponent,
    ZoomchartsComponentComponent,
    TimechartComponent,
    NetchartComponent,
    GeochartComponent
  ],
  providers: [ZoomchartsService, ChartService],
  entryComponents: [
    PiechartComponent,
    FacetchartComponent,
    TimechartComponent,
    NetchartComponent,
    GeochartComponent
  ],
  exports: [ZoomchartsComponentComponent]
})

export class ZoomchartsModule {
  public static forRoot(config): ModuleWithProviders<ZoomchartsModule> {
    return {
      ngModule: ZoomchartsModule,
      providers: [
        ZoomchartsModule,
        { provide: 'config', useValue: config }
      ]
    };
  }
}
